export const environment = {
    production: true,
    name: "Production",
    context: "/admin/api",
    version: "1.0.70",
    server: "PROD",

    appearance: {
        scheme: 'auto',
        layout: 'classy',
        theme: "theme-default"
    },

    firebaseConfig: {
        apiKey: "AIzaSyAA1akJ1GJ8fkuCN0ncmbOCgxxblNXss1M",
        authDomain: "drivr-5eb02.firebaseapp.com",
        projectId: "drivr-5eb02",
        storageBucket: "drivr-5eb02.firebasestorage.app",
        messagingSenderId: "142692601182",
        appId: "1:142692601182:web:8e8172ce687380e6b7d3cf",
        measurementId: "G-5L849ZJRJN"
    },

    externalDocumentPath: "/home/ubuntu/external-documents/",
};
